import "./style.css";
import "./estilos/botones.css";
import "./estilos/menu.css";
import "./estilos/menuLateral.css";
import "./estilos/modalLote.css";
import "./estilos/proyecto.css";
import "./js/tabs.js";
import * as THREE from "three";
import { OrbitControls } from "three/examples/jsm/controls/OrbitControls.js";
import * as dat from "lil-gui";
import { SVGLoader } from "three/examples/jsm/loaders/SVGLoader.js";
import { Raycaster } from "three";
import gsap from "gsap";

//Recorridos 360
const modalTour = document.querySelector("#modal-tour"),
  tourApto = modalTour.querySelector(".appicua-tour"),
  btnTour = document.querySelector(".btn-360"),
  btnTourCerrar = modalTour.querySelector(".btn-cerrar-360"),
  cargando = document.getElementById("pantalla-carga"),
  barraCarga = cargando.querySelector(".loading-barra"),
  hotspotsWrappers = document.querySelectorAll(".hotspots-wrapper");
/**
 * Inventario
 */

function readTextFile(file, callback) {
  var rawFile = new XMLHttpRequest();
  rawFile.overrideMimeType("application/json");
  rawFile.open("GET", file, true);
  rawFile.onreadystatechange = function () {
    if (rawFile.readyState === 4 && rawFile.status == "200") {
      callback(rawFile.responseText);
      console.log(inventario)
      cargarMascaras()
    }
  };
  rawFile.send(null);
}
//usage:
let inventario

readTextFile("https://unidadesreservasnorte.vercel.app/unidades?token=54a8ce618e91b0b13665e2f9", function (text) {
  const archivo = JSON.parse(text);
  inventario = archivo.data.records;
});

//Elementos a pintar
const menuLateral = document.getElementById("menu-lateral"),
  modalLote = document.getElementById("modal-lote"),
  dataNombre = document.querySelectorAll(".data-nombre"),
  dataTipoCasa = document.querySelectorAll(".data-tipoCasa"),
  dataAreaConstruida = document.querySelectorAll(".data-areaConstruida"),
  dataAreaLote = document.querySelector(".data-areaLote");

//Este objeto se actualiza al dar click en las máscaras
let inventarioActual = {
  nombre: "",
  tipoCasa: "",
  disponibilidad: "",
  areaConstruida: "",
  areaLote: "",
};

const pintarInfo = () => {
  dataNombre.forEach((campo) => {
    campo.innerHTML = inventarioActual.nombre;
  });
  dataTipoCasa.forEach((campo) => {
    campo.innerHTML = `Casa ${inventarioActual.tipoCasa}`;
  });
  dataAreaConstruida.forEach((campo) => {
    campo.innerHTML = inventarioActual.areaConstruida;
  });
  dataAreaLote.innerHTML = inventarioActual.areaLote;

  menuLateral.dataset.tipo = inventarioActual.tipoCasa;
  modalLote.dataset.tipo = inventarioActual.tipoCasa;
};

const cargar360 = (tipoCasa) => {
  const ruta = tipoCasa === 'granada' ? 'https://mpembed.com/show/?m=xm4i3mpyMBG&ts=1&help=0'
    : tipoCasa === 'navarra' ? 'https://www.chroma-studio.net/360/provivienda/reserva_del_norte/casa_navarra/tour.html'
      : tipoCasa === 'castilla' ? 'https://mpembed.com/show/?m=MMQb7j3LPF9&ts=1&help=0'
        : 'https://mpembed.com/show/?m=MMQb7j3LPF9&ts=1&help=0';//Castilla por defecto

  tourApto.src = ruta
}
/**
 * MAQUETA
 */

//Menus maqueta

let anchoModal = 0;

// Debug
const gui = new dat.GUI();
let mapaFolder = gui.addFolder("Mapa"),
  lucesFolder = gui.addFolder("Mapa"),
  coloresFolder = gui.addFolder("Colores");
mapaFolder.close();

// Canvas
const canvas = document.querySelector("canvas.webgl");
// Scene
const scene = new THREE.Scene();
/**
 * Loaders
 */

const loadingManager = new THREE.LoadingManager(
  //Cargado
  () => {
    console.log("MAQUETA LISTA");
    cargando.classList.add("cargado");
    setTimeout((_) => cargando.remove(), 1200);
  },
  //En progreso
  (itemUrl, itemsLoaded, itemsTotal) => {
    const progressRatio = itemsLoaded / itemsTotal;
    barraCarga.style.transform = `scaleX(${progressRatio})`;
  }
);

const svgloader = new SVGLoader(loadingManager),
  textureLoader = new THREE.TextureLoader(loadingManager);

// Axes helper
const axesHelper = new THREE.AxesHelper(2);
//scene.add(axesHelper)

//Colores
const colores = {
  colorEter: "#081C15",
  colorBase: "#FFFFFF",
  colorOsc: "#cccccc",
  colorBruma: "#2C312D",
  colorHelper: "#FF0000",
  colorLote: "#B1FF9D",
  colorLoteHover: "#F0EBE2",//"#F0EBE2"
  colorLoteSeleccionado: "#F0EBE2",//"#005157"
  colorLoteVendido: "#071014",

  colorNavarra: '#90ccb7',
  colorCastilla: '#8a5def',
  colorGranada: '#e0ca53',
};

/**
 * Texturas
 */

//Cargar Texturas
const textura_mapa = textureLoader.load("img/reserva-del-norte-referencia.png"),
  textura_terreno = textureLoader.load(
    "img/reserva-del-norte-con-terreno-numerado.webp"
  ),
  textura_nube1 = textureLoader.load("img/nubes/nube-1b.png"),
  textura_nube4 = textureLoader.load("img/nubes/nube-4.png");

/**
 * Materiales
 */
const mat_piso = new THREE.MeshBasicMaterial({
  color: colores.colorBase,
  map: textura_mapa,
  transparent: true,
  opacity: 0.75,
});
const mat_terreno = new THREE.MeshBasicMaterial({
  color: colores.colorBase,
  map: textura_terreno,
});

//Nubes
const mat_nube1 = new THREE.MeshStandardMaterial({
  transparent: true,
  map: textura_nube1,
  side: THREE.DoubleSide,
  depthTest: false,
});
const mat_nube4 = new THREE.MeshStandardMaterial({
  transparent: true,
  map: textura_nube4,
  side: THREE.DoubleSide,
  depthTest: false,
});

//Test

const materialTransparente = new THREE.MeshBasicMaterial({
  transparent: true,
  opacity: 0,
  color: colores.colorHelper,
  //wireframe: true
});

const materialHelper = new THREE.MeshStandardMaterial({
  color: colores.colorHelper,
});

//Lotes

let opacidad = 0.5,
  opacidadHover = 0.7;

const mat_Lote = new THREE.MeshStandardMaterial({
  color: colores.colorLote,
  transparent: true,
  opacity: opacidad,
  side: THREE.DoubleSide,
  depthTest: false,
});
const mat_LoteHover = new THREE.MeshStandardMaterial({
  color: colores.colorLoteHover,
  transparent: true,
  opacity: opacidadHover,
  side: THREE.DoubleSide,
  depthTest: false,
});
const mat_LoteSeleccionado = new THREE.MeshStandardMaterial({
  color: colores.colorLoteSeleccionado,
  transparent: true,
  opacity: opacidadHover,
  side: THREE.DoubleSide,
  depthTest: false,
});
const mat_LoteVendido = new THREE.MeshStandardMaterial({
  transparent: true,
  opacity: opacidad,
  side: THREE.DoubleSide,
  depthTest: false,
  color: colores.colorLoteVendido,
});
//Colores de lotes proyecto
const mat_LoteNavarra = new THREE.MeshStandardMaterial({
  color: colores.colorNavarra,
  transparent: true,
  opacity: opacidad,
  side: THREE.DoubleSide,
  depthTest: false,
});
const mat_LoteCastilla = new THREE.MeshStandardMaterial({
  color: colores.colorCastilla,
  transparent: true,
  opacity: opacidad,
  side: THREE.DoubleSide,
  depthTest: false,
});
const mat_LoteGranada = new THREE.MeshStandardMaterial({
  color: colores.colorGranada,
  transparent: true,
  opacity: opacidad,
  side: THREE.DoubleSide,
  depthTest: false,
});
/**
 * Interaccion
 */
const lilGUI = document.querySelector(".lil-gui");

function toogleGUI() {
  lilGUI.classList.toggle("oculto");
}

toogleGUI();

window.addEventListener("keydown", (event) => {
  if (event.key === "l") {
    toogleGUI();
  }
});

const formatoNumero = Intl.NumberFormat("de-DE");

//Crear hotspots

//AislarEtapas
const btnEtapas = document.querySelectorAll(".btn-etapa"),
  btnVolverGeneral = menuLateral.querySelector(".btn-volver");

function aislarEtapa(cameraTarget, cameraPosition) {
  controls.enabled = false;

  btnEtapas.forEach((btn) => btn.classList.add("oculto"));

  menuLateral.classList.remove("oculto");

  //Centrar cámara
  gsap.to(controls.target, {
    duration: 1.0,
    x: cameraTarget.x,
    y: cameraTarget.y,
    z: cameraTarget.z,
    onUpdate: function () { },
    onComplete: function () { },
  });

  //Mover cámara
  gsap.to(camera.position, {
    duration: 1.0,
    x: cameraPosition.x,
    y: cameraPosition.y,
    z: cameraPosition.z,
    onUpdate: function () {
      controls.update();
    },
    onComplete: function () {
      //hotspotWrapper.classList.remove("alejado");
      //Limitar zoom
      controls.minDistance = 15;
      controls.maxDistance = 55;
      controls.enablePan = true;
      controls.enableZoom = true;
      controls.enableRotate = true;
      controls.enabled = true;
    },
  });
}
function quitarAislamiento() {
  controls.enabled = false;
  controls.maxDistance = 75;
  btnEtapas.forEach((btn) => btn.classList.remove("oculto"));
  btnVolverGeneral.classList.add("oculto");

  //Activar mascaras
  mapa.traverse((child) => {
    if (child.type === "Mesh") {
      child.visible = false;
      child.layers.disable(1);
    }
  });

  //Centrar cámara
  gsap.to(controls.target, {
    duration: 1.0,
    x: 0,
    y: 0,
    z: 0,
    onUpdate: function () { },
    onComplete: function () { },
  });

  //Mover cámara
  gsap.to(camera.position, {
    duration: 1.0,
    x: 0,
    y: 75,
    z: 1,
    onUpdate: function () {
      controls.update();
    },
    onComplete: function () {
      controls.enablePan = false;
      controls.enableZoom = false;
      controls.enableRotate = false;
      controls.enabled = true;
    },
  });
}

const btnEtapa1 = document.getElementById("btn-etapa-1"),
  btnEtapa2 = document.getElementById("btn-etapa-2"),
  targetEtapa1 = { x: -15, y: 0, z: 18 },
  posicionEtapa1 = { x: -15, y: 35, z: 18 },
  targetEtapa2 = { x: 5, y: 0, z: -15 },
  posicionEtapa2 = { x: 5, y: 46, z: -15 };

btnEtapa1.addEventListener("click", (event) => {
  event.preventDefault();
  aislarEtapa(targetEtapa1, posicionEtapa1);
  //Activar mascaras
  mapa.traverse((child) => {
    if (child.type === "Mesh") {
      child.visible = true;
      if (child.userData.disponibilidad === "Disponible") {
        child.layers.enable(1);
      }

    }
  });
});

//Etapa2
btnEtapa2.addEventListener("click", (event) => {
  event.preventDefault();
  aislarEtapa(targetEtapa2, posicionEtapa2);
  //Activar mascaras
  mapa.traverse((child) => {
    if (child.type === "Mesh") {
      child.visible = true;
      if (child.userData.disponibilidad === "Disponible") {
        child.layers.enable(1);
      }

    }
  });
});
//Test camaras
document.addEventListener('keydown', function(event) {
  if (event.key === 'c' || event.key === 'C') {
    console.log(camera.position);
  }
});

btnVolverGeneral.addEventListener("click", (event) => {
  event.preventDefault();
  menuLateral.classList.add("oculto");
  quitarAislamiento();
});

//Click máscaras lote

canvas.addEventListener("click", () => {
  if (interseccionActual) {
    const loteActual = interseccionActual.object;

    menuLateral.classList.remove("infoOculta");

    //Lotes
    /*if (loteActual.userData.tipo === "lote") {*/
    //Tomar manzana y numero
    const loteManzana = loteActual.userData.manzana,
      loteNumero = loteActual.userData.numero;
    //Quitar otro seleccionado
    mapa.traverse((lote) => {
      if (lote.userData.estado === "activo") {
        lote.userData.estado = "reposo";
        lote.material = mat_Lote;
      }
    });
    //Seleccionar este
    loteActual.userData.estado = "activo";
    loteActual.material = mat_LoteSeleccionado;
    //Consultar inventario
    let lote = inventario.find((obj) => {
      return (
        obj.Numero_Unidad_Corto__c === loteNumero &&
        obj.Numero_de_la_Manzana_Corto__c === loteManzana
      );
    });

    inventarioActual.nombre =
      lote.Numero_de_la_Manzana_Corto__c + lote.Numero_Unidad_Corto__c;

    const tipoCasaNombreBonito = lote.vuu_modelo__r.Name.includes("GRANADA")
      ? "granada"
      : lote.vuu_modelo__r.Name.includes("GANADA")
        ? "granada"
        : lote.vuu_modelo__r.Name.includes("CASTILLA")
          ? "castilla"
          : lote.vuu_modelo__r.Name.includes("NAVARRA")
            ? "navarra"
            : "general";

    inventarioActual.tipoCasa = tipoCasaNombreBonito;
    inventarioActual.disponibilidad = lote.Estado_Unidad__c;
    inventarioActual.areaConstruida = lote.Area_Construccion__c;
    inventarioActual.areaLote = lote.vuu_area_lote__c;

    pintarInfo();
    cargar360(tipoCasaNombreBonito);

    /*}*/

  }
});
//Abrir y cerrar modal lote
const btnModal = document.getElementById('btn-modal'),
  btnModalCerrar = modalLote.querySelector('.btn-volver')
btnModal.addEventListener('click', (event) => {
  event.preventDefault()
  modalLote.classList.remove('oculto')
})
btnModalCerrar.addEventListener('click', (event) => {
  event.preventDefault()
  modalLote.classList.add('oculto')
})
//Abrir y cerrar Tour 360
btnTour.addEventListener('click', (event) => {
  event.preventDefault()
  modalTour.classList.add('activo')
})
btnTourCerrar.addEventListener('click', (event) => {
  event.preventDefault()
  modalTour.classList.remove('activo')
})
//Tabs
const tabs = document.querySelectorAll('.tab'),
  tabsContenido = document.querySelectorAll('.tab-contenido')

tabs.forEach(tab => {
  tab.addEventListener('click', () => {
    document.querySelector('.tab.activo').classList.remove('activo')
    document.querySelector('.tab-contenido.activo').classList.remove('activo')

    tab.classList.add('activo')
    const contenido = tab.dataset.tab
    document.querySelector(`.tab-contenido.${contenido}`).classList.add('activo')
  })
})
/**
 * Mascaras
 */

//Mapa
const mapa = new THREE.Group();
const mapaVendidos = new THREE.Group();

mapa.rotation.x = Math.PI * 0.5;
mapa.position.set(-46.75, 0.001, -39.71);
mapa.scale.set(0.875, 0.875, 0.875);

mapaVendidos.rotation.x = Math.PI * 0.5;
mapaVendidos.position.set(-46.75, 0.001, -39.71);
mapaVendidos.scale.set(0.875, 0.875, 0.875);

gui.add(mapa.position, "x", -150, 150, 0.01).name("Mapa X");
gui.add(mapa.position, "y", -150, 150, 0.01).name("Mapa Y");
gui.add(mapa.position, "z", -150, 150, 0.01).name("Mapa Z");

gui.add(mapa.scale, "x", 0.8, 1, 0.0001).name("Mapa sX");
gui.add(mapa.scale, "y", 0.8, 1, 0.0001).name("Mapa sY");
gui.add(mapa.scale, "z", 0.8, 1, 0.0001).name("Mapa sZ");

scene.add(mapa);
scene.add(mapaVendidos);

//Base
function cargarMascaras() {
  svgloader.load(
    "mascaras/mascaras-lotes.svg",
    function (data) {
      const paths = data.paths;
      for (let i = 0; i < paths.length; i++) {
        const path = paths[i],
          meshID = path.userData.node.id,
          manzana = meshID.substring(0, 1),
          numero = meshID.substring(1, meshID.length),
          shape = SVGLoader.createShapes(path),
          geometry = new THREE.ShapeGeometry(shape),
          mesh = new THREE.Mesh(geometry, mat_Lote);

        mesh.userData.id = meshID;
        mesh.userData.manzana = manzana;
        mesh.userData.numero = numero;
        mesh.userData.tipo = "lote";
        mesh.userData.estado = "reposo";
        mesh.visible = false;

        let lote = inventario.find((obj) => {
          return (
            obj.Numero_Unidad_Corto__c === numero &&
            obj.Numero_de_la_Manzana_Corto__c === manzana
          );
        });

        if (lote) {

          if (lote.Estado_Unidad__c == "No Disponible" || lote.Estado_Unidad__c == "Pendiente Validación") {
            mesh.userData.disponibilidad = "Vendido"
            mesh.material = mat_LoteVendido
            //mapaVendidos.add(mesh);
            mesh.layers.disableAll
            mapa.add(mesh);
          } else {
            mesh.userData.disponibilidad = "Disponible"

            const tipoCasaNombreBonito = lote.vuu_modelo__r.Name.includes("GRANADA")
              ? "granada"
              : lote.vuu_modelo__r.Name.includes("GANADA")
                ? "granada"
                : lote.vuu_modelo__r.Name.includes("CASTILLA")
                  ? "castilla"
                  : lote.vuu_modelo__r.Name.includes("NAVARRA")
                    ? "navarra"
                    : "general";

            mesh.userData.tipoCasa = tipoCasaNombreBonito

            if (mesh.userData.tipoCasa == 'granada') {
              mesh.material = mat_LoteGranada
            } else if (mesh.userData.tipoCasa == 'castilla') {
              mesh.material = mat_LoteCastilla
            } else if (mesh.userData.tipoCasa == 'navarra') {
              mesh.material = mat_LoteNavarra
            }
            mesh.layers.enable(1)
            mapa.add(mesh);
          }
          
        } else{
          console.log(meshID, ' no está en el inventario')
          mesh.userData.disponibilidad = "Vendido"
            mesh.material = mat_LoteVendido
            //mapaVendidos.add(mesh);
            mesh.layers.disableAll
            mapa.add(mesh);
        }

      }

    },
    function (xhr) {
      console.log((xhr.loaded / xhr.total) * 100 + "% cargado");
    },
    function (error) {
      console.log("Error con máscaras de lotes");
      console.log(error);
    }
  );
}



//Sectores Generales
const sectores = new THREE.Group();
sectores.name = "sectores";
mapa.add(sectores);
sectores.rotation.x = Math.PI;
sectores.position.set(907.3, 586.17, 0.01);
gui.add(sectores.position, "x", -1000, 1000, 0.01).name("sectores X");
gui.add(sectores.position, "y", -1000, 1000, 0.01).name("sectores Y");
gui.add(sectores.position, "z", -1000, 1000, 0.01).name("sectores Z");

//Lotes
const lotes = new THREE.Group();

lotes.name = "lotes";

mapa.add(lotes);

lotes.rotation.x = Math.PI;
lotes.position.set(907.59, 586.12, 0.02);

gui.add(lotes.position, "x", -1000, 1000, 0.01).name("lotes X");
gui.add(lotes.position, "y", -1000, 1000, 0.01).name("lotes Y");
gui.add(lotes.position, "z", -1000, 1000, 0.01).name("lotes Z");

//Info Lotes

/**
 * Lights
 */
//Ambient
const ambientLight = new THREE.AmbientLight(0xffffff, 1);
lucesFolder
  .add(ambientLight, "intensity")
  .min(0)
  .max(1)
  .step(0.001)
  .name("Ambient");

scene.add(ambientLight);

/**
 * Floor
 */

//Terreno

const terreno = new THREE.Mesh(
  new THREE.PlaneGeometry(200, 200, 2, 2),
  mat_terreno
);
terreno.receiveShadow = true;
terreno.rotation.x = -Math.PI * 0.5;
terreno.position.y = -0.05;
terreno.position.z = 5;
scene.add(terreno);

//Agregar nubes
const nube1 = new THREE.Mesh(new THREE.PlaneGeometry(138, 72, 2, 2), mat_nube1);
nube1.rotation.x = -Math.PI * 0.5;
nube1.position.y = 25;
nube1.position.x = 40;
function animarNube1() {
  gsap.to(nube1.position, {
    duration: 100,
    x: -120,
    onUpdate: function () { },
    onComplete: function () {
      nube1.position.x = 120;
      animarNube1();
    },
  });
}
animarNube1();

scene.add(nube1);

const nube2 = new THREE.Mesh(new THREE.PlaneGeometry(82, 48, 2, 2), mat_nube4);
nube2.rotation.x = -Math.PI * 0.5;
nube2.position.y = 8; //4
nube2.position.z = 20;
nube2.position.x = 20;
function animarNube2() {
  gsap.to(nube2.position, {
    duration: 200,
    x: -60,
    onUpdate: function () { },
    onComplete: function () {
      nube2.position.x = 100;
      animarNube2();
    },
  });
}
animarNube2();

scene.add(nube2);

const nube3 = new THREE.Mesh(new THREE.PlaneGeometry(82, 48, 2, 2), mat_nube4);
nube3.rotation.x = -Math.PI * 0.5;
nube3.position.y = 4; //3
nube3.position.z = 10;
nube3.position.x = 100;
function animarNube3() {
  gsap.to(nube3.position, {
    duration: 200,
    x: -100,
    onUpdate: function () { },
    onComplete: function () {
      nube3.position.x = 100;
      animarNube3();
    },
  });
}
animarNube3();

scene.add(nube3);
/**
 * Sizes
 */

const sizes = {
  width: window.innerWidth - anchoModal,
  height: window.innerHeight,
};

function redimensionar() {
  sizes.width = window.innerWidth - anchoModal;
  sizes.height = window.innerHeight;

  // Update camera
  camera.aspect = sizes.width / sizes.height;
  camera.updateProjectionMatrix();

  // Update renderer
  renderer.setSize(sizes.width, sizes.height);
  renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
  //Actualizar hotspot wrapper
  hotspotsWrappers.forEach((item) => {
    item.style.width = sizes.width + "px";
    item.style.height = sizes.height + "px";
  });
}
window.addEventListener("resize", () => {
  redimensionar();
});

/**
 * Camera
 */
// Base camera
const camera = new THREE.PerspectiveCamera(
  60,
  sizes.width / sizes.height,
  0.1,
  2500
);

camera.position.set(0, 75, 1);

scene.add(camera);
// Controls
const controls = new OrbitControls(camera, canvas);
controls.target.set(0, 0, 0);
controls.enableDamping = true;
controls.minPolarAngle = 0;
controls.maxPolarAngle = Math.PI * 0.2;
//controls.minDistance = 65;
//controls.maxDistance = 85; //75
controls.enablePan = false;
controls.enableZoom = false;
controls.enableRotate = false;
controls.mouseButtons = {
  LEFT: THREE.MOUSE.PAN,
  MIDDLE: THREE.MOUSE.DOLLY,
  RIGHT: THREE.MOUSE.ROTATE,
};

controls.touches = {
  TWO: THREE.TOUCH.ROTATE,
  ONE: THREE.TOUCH.DOLLY_PAN,
};

/**
 * Renderer
 */
const renderer = new THREE.WebGLRenderer({
  canvas: canvas,
  antialias: true,
});
//renderer.shadowMap.enabled = true;
//renderer.shadowMap.type = THREE.PCFSoftShadowMap;
renderer.setSize(sizes.width, sizes.height);
renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
renderer.antialias = true;
renderer.setClearColor(colores.colorEter);

//Niebla
const niebla = new THREE.Fog(colores.colorBruma, 40, 100); //40,100
//scene.fog = niebla;

/**
 * Hotspots
 */

const bolaHelper = new THREE.Mesh(
  new THREE.SphereGeometry(0.1, 16, 16),
  new THREE.MeshBasicMaterial({ color: colores.colorHelper })
);
bolaHelper.position.set(0, 0, 0);

//scene.add(bolaHelper);
gui.add(bolaHelper.position, "x", -70, 70, 0.01);
gui.add(bolaHelper.position, "y", -70, 70, 0.01);
gui.add(bolaHelper.position, "z", -70, 70, 0.01);

//Brujula
const brujula_dir = new THREE.Vector3(),
  brujula_sph = new THREE.Spherical(),
  brujula = document.getElementById("brujula");

/**
 * Debug Colores
 */
coloresFolder
  .addColor(colores, "colorBruma")
  .onChange(() => {
    niebla.color.set(colores.colorBruma);
  })
  .name("Bruma");

//Pista: Para evitar Bug Hotspots
var frustum = new THREE.Frustum();
/**
 * Raycaster aptos
 */
const raycasterLotes = new Raycaster();
const mouse = new THREE.Vector2();
raycasterLotes.layers.set(1);

window.addEventListener("mousemove", (event) => {
  mouse.x = (event.clientX / sizes.width) * 2 - 1;
  mouse.y = -(event.clientY / sizes.height) * 2 + 1;
});

/**
 * Animate
 */
const clock = new THREE.Clock();
let previousTime = 0;
let interseccionActual = null;

const tick = () => {
  const elapsedTime = clock.getElapsedTime();
  const deltaTime = elapsedTime - previousTime;
  previousTime = elapsedTime;

  // Brujula
  camera.getWorldDirection(brujula_dir);
  brujula_sph.setFromVector3(brujula_dir);
  brujula.style.transform = `rotate(${THREE.Math.radToDeg(brujula_sph.theta) - 180
    }deg)`;

  //Lotes interactividad

  raycasterLotes.setFromCamera(mouse, camera);
  const objetosEvaluar = mapa.children;
  const intersecciones = raycasterLotes.intersectObjects(objetosEvaluar, true);

  if (intersecciones.length) {
    interseccionActual = intersecciones[0];
    //Hover
    mapa.traverse((lote) => {
      if (lote.userData.estado === "reposo") {
        if (lote.userData.tipoCasa == 'granada') {
          lote.material = mat_LoteGranada
        } else if (lote.userData.tipoCasa == 'castilla') {
          lote.material = mat_LoteCastilla
        } else if (lote.userData.tipoCasa == 'navarra') {
          lote.material = mat_LoteNavarra
        } else {
          lote.material = mat_LoteVendido
        }
      }
    });
    interseccionActual.object.material = mat_LoteHover;
  } else {
    interseccionActual = null;
  }

  controls.update();

  // Render
  renderer.render(scene, camera);
  window.requestAnimationFrame(tick);
};
tick();
